import UnitConsumedIcon from "../components/dashboard/icons/UnitConsumed";
import { useState } from "react";
import { useEffect } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";

const UnitsConsumed = ({ data, start, end, country }) => {
  const { facilities } = useSelector((state) => state.stationList);
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);
  const [totalHoursConsumed, setTotalHoursConsumed] = useState(0);
  const [totalUnitsConsumed, setTotalUnitsConsumed] = useState(0);
  const [totalAmountSpent, setTotalAmountSpent] = useState(0);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    if (data?.view_facility_revenue_aggregate?.nodes) {
      let hours_consumed = data?.view_facility_revenue_aggregate?.nodes.reduce(
        (prev, cur) => {
          const stopDate = new Date(cur.stop_at * 1000);
          const stopInRange = stopDate >= start && stopDate <= end;

          return country === "Thailand" && !stopInRange
            ? prev
            : prev + Number(cur.hours_consumed);
        },
        0
      );
      let units_consumed = data?.view_facility_revenue_aggregate?.nodes.reduce(
        (prev, cur) => {
          const stopDate = new Date(cur.stop_at * 1000);
          const stopInRange = stopDate >= start && stopDate <= end;

          return country === "Thailand" && !stopInRange
            ? prev
            : prev + Number(cur.units_consumed);
        },
        0
      );
      let total_amount_spent =
        data?.view_facility_revenue_aggregate?.nodes.reduce(
          (prev, cur) => prev + Number(cur.total_amount_spent),
          0
        );
      hours_consumed = hours_consumed === 0 ? "0" : hours_consumed.toFixed(3);
      units_consumed =
        units_consumed === 0 ? "0" : (units_consumed / 1000).toFixed(3);
      total_amount_spent =
        total_amount_spent === 0 ? "0" : total_amount_spent.toFixed(3);
      setTotalHoursConsumed(Number(hours_consumed).toLocaleString());
      setTotalUnitsConsumed(Number(units_consumed).toLocaleString());
      setTotalAmountSpent(Number(total_amount_spent).toLocaleString());
    }
    setLoading(false);
  }, [data, selectedFacility, selectedDate]);

  const handleDownloadExcelSheet = () => {
    const workbook = XLSX.utils.book_new();

    const excelData = data?.view_facility_revenue_aggregate?.nodes
      .reduce((arr, obj) => {
        const index = arr.findIndex(
          (item) => item.facility_id === obj.facility_id
        );
        if (index > -1) {
          arr[index] = {
            ...arr[index],
            total_units_consumed:
              arr[index].total_units_consumed +
              Number(obj.units_consumed) / 1000,
            total_hours_consumed:
              arr[index].total_hours_consumed + Number(obj.hours_consumed),
            total_amount_spent:
              arr[index].total_amount_spent + Number(obj.total_amount_spent),
          };
          return arr;
        } else {
          return [
            ...arr,
            {
              facility_id: obj.facility_id,
              name: obj.facility_name,
              total_units_consumed: Number(obj.units_consumed) / 1000,
              total_hours_consumed: Number(obj.hours_consumed),
              total_amount_spent: Number(obj.total_amount_spent),
              from: selectedDate?.start?.toISOString(),
              to: selectedDate?.end?.toISOString(),
            },
          ];
        }
      }, [])
      .map((item) => {
        const { facility_id, ...fields } = item;
        return { ...fields };
      });

    const fileName =
      selectedFacility.name === "All"
        ? "All-report"
        : selectedFacility?.name.length > 20
        ? selectedFacility?.name.slice(0, 20)
        : selectedFacility?.name;

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, fileName);

    if (workbook.SheetNames.length > 0) {
      const sheet_name = `${fileName}.xlsx`;
      XLSX.writeFile(workbook, sheet_name);
    }
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      bgcolor={"white"}
      justifyContent={"space-between"}
      borderRadius={"16px"}
      padding={"24px"}
      height="150px"
      position="relative"
    >
      <Typography>
        <Typography
          variant="subtitle"
          fontSize="12px"
          fontWeight="600"
          style={{ textWrap: "nowrap" }}
        >
          {t("hoursConsumed")}{" "}
          {loading ? (
            <span style={{ color: "#467CEB" }}> {t("loading")}...</span>
          ) : (
            ""
          )}
        </Typography>
        <Typography
          variant="h6"
          fontSize="18px"
          fontWeight="700"
          sx={{ marginBottom: "10px" }}
          style={{ textWrap: "nowrap" }}
        >
          {totalHoursConsumed} <span style={{ fontSize: "12px" }}>Hours</span>
        </Typography>
        <Typography
          variant="subtitle"
          fontSize="12px"
          fontWeight="600"
          style={{ textWrap: "nowrap" }}
        >
          {t("unitsConsumed")}{" "}
          {loading ? (
            <span style={{ color: "#467CEB" }}> {t("loading")}...</span>
          ) : (
            ""
          )}
        </Typography>
        <Typography
          variant="h6"
          fontSize="18px"
          fontWeight="700"
          style={{ textWrap: "nowrap" }}
        >
          {totalUnitsConsumed} <span style={{ fontSize: "12px" }}>kWh</span>
        </Typography>
      </Typography>
      {!loading && (
        <Tooltip
          title="Download Report"
          sx={{
            position: "absolute",
            top: "-3px",
            right: "0px",
            color: "grey",
          }}
        >
          <IconButton>
            <Box onClick={handleDownloadExcelSheet}>
              <ArrowDownwardIcon />
            </Box>
          </IconButton>
        </Tooltip>
      )}
      <UnitConsumedIcon />
    </Box>
  );
};
export default UnitsConsumed;
